import { defineRecipe } from "@chakra-ui/react"

export const textRecipe = defineRecipe({
  base: {
    fontFamily: "body"
  },
})